var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Tailless-Line-Arrow-Down-1--Streamline-Sharp"},React.createElement("g",{"id":"tailless-line-arrow-down-1--arrow-down-keyboard"},React.createElement("path",{"id":"Rectangle 20","d":"M9.30586 3.00586L5.49961 6.81211L1.69336 3.00586","stroke":"#141414","strokeWidth":"1.3"}))));
}

ChevronDown.defaultProps = {"width":"11","height":"10","viewBox":"0 0 11 10","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
